<div class="aig-modifyData u-my-8 container u-minheight-vh-60">
  <div class="row">
    <div class="col-12">
      <aig-breadcrumb [config]="[
      { title: 'Área de cliente', link: '/area-cliente' }
]"></aig-breadcrumb>
    </div>
  </div>
  <div class="row">
    <div class="col-12 u-py-8">
      <h2 class="u-color-primary1 u-fw-400 u-fs-40 u-text-center">
        Modificar datos de la póliza
      </h2>
    </div>
  </div>
  <form class="aig-modifyData__form" [formGroup]="modifiedDataForm">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-3">
        <div class="e-field">
          <label for="policy-holder" class="e-field__label">
            Tomador del seguro <span></span>
          </label>
          <input
            type="text"
            class="e-field__input"
            id="policy-holder"
            formControlName="tomador"
          />
        </div>
      </div>
      <div class="col-12 col-md-4 col-lg-3">
        <div class="e-field">
          <label for="nationality-field" class="e-field__label">
            Nacionalidad <span></span>
          </label>
          <input
            type="text"
            class="e-field__input"
            id="nationality-field"
            formControlName="nacionalidad"
          />
        </div>
      </div>
      <div class="col-12 col-md-4 col-lg-3">
        <div class="e-field">
          <label for="identity-number" class="e-field__label">
            DNI/NIF/NIE <span></span>
          </label>
          <input
            type="text"
            class="e-field__input"
            id="identity-number"
            formControlName="dni"
          />
        </div>
      </div>
      <div class="col-12 col-md-4 col-lg-3">
        <div class="e-field">
          <label for="associated-email" class="e-field__label">
            Email asociado a póliza <span></span>
          </label>
          <input
            type="email"
            class="e-field__input"
            id="associated-email"
            formControlName="email"
            autocomplete="on"
            required
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-3 col-lg-4">
        <div class="e-field">
          <label
            for="associated-phone"
            class="e-field__label u-ellipsis--line u-size-per-15"
          >
            Teléfono asociado a póliza <span></span>
          </label>
          <input
            type="tel"
            class="e-field__input"
            id="associated-phone"
            formControlName="telefono"
            autocomplete="on"
            required="true"
          />
        </div>
      </div>
      <div class="col-12 col-md-9 col-lg-8" (click)="editIBAN()">
        <aig-iban-field
          [parentForm]="modifiedDataForm"
          [mandatory]="ibanMandatory"
          (ibanChange)="updateIban($event)"
        ></aig-iban-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-12 col-lg-4">
        <div class="e-field">
          <label for="adress-field" class="e-field__label">
            Dirección <span></span>
          </label>
          <input
            type="text"
            class="e-field__input"
            id="adress-field"
            formControlName="direccion"
            autocomplete="on"
            required="true"
          />
        </div>
      </div>
      <div class="col-12 col-md-4 col-lg">
        <div class="e-field">
          <label for="block-field" class="e-field__label">
            Bloque<span></span>
          </label>
          <input
            type="text"
            class="e-field__input"
            id="block-field"
            formControlName="bloque"
            autocomplete="on"
            required="true"
          />
        </div>
      </div>
      <div class="col-12 col-md-4 col-lg">
        <div class="e-field">
          <label for="floor-field" class="e-field__label">
            Piso<span></span>
          </label>
          <input
            type="text"
            class="e-field__input"
            id="floor-field"
            formControlName="piso"
            autocomplete="on"
            required="true"
          />
        </div>
      </div>
      <div class="col-12 col-md-4 col-lg">
        <div class="e-field">
          <label for="door-field" class="e-field__label">
            Puerta<span></span>
          </label>
          <input
            type="text"
            class="e-field__input"
            id="door-field"
            formControlName="puerta"
            autocomplete="on"
            required="true"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4">
        <div class="e-field">
          <label for="province-field" class="e-field__label">
            Provincia<span></span>
          </label>
          <input
            type="text"
            class="e-field__input"
            id="province-field"
            formControlName="provincia"
            required="true"
          />
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-2">
        <div class="e-field">
          <label for="postalCode-field" class="e-field__label">
            CP<span></span>
          </label>
          <input
            type="text"
            class="e-field__input"
            id="postalCode-field"
            formControlName="cp"
            required="true"
          />
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <div class="e-field">
          <label for="population-field" class="e-field__label">
            Población<span></span>
          </label>
          <input
            type="text"
            class="e-field__input"
            id="population-field"
            formControlName="poblacion"
            required="true"
          />
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <div class="e-field">
          <label for="country-field" class="e-field__label">
            País de residencia<span></span>
          </label>
          <input
            type="text"
            class="e-field__input"
            id="country-field"
            formControlName="pais"
            required="true"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="aig-modifyData__foot p-flexce u-pt-7">
          <button
            type="submit"
            class="aig-modifyData__btn e-btn--primary"
            id="save-btn"
            [disabled]="formHasChanged() == false"
            (click)="saveChanges()"
          >
            <p class="u-fs-16 u-fw-600">Guardar cambios</p>
          </button>
        </div>
      </div>
    </div>
  </form>
  <div class="row">
    <div class="col-12">
      <div class="aig-modifyData__legend p-flexcc u-pt-8">
        <p class="u-fs-18 u-fw-400 u-text-center">
          En caso de que tenga cualquier consulta puede ponerse en contacto con
          nosotros escribiendo a
          <a
            class="u-fs-18 u-fw-400 u-color-selected1 u-cursor-pointer"
            href="mailto:backoffice.caixa@icp.es"
            >backoffice.caixa&#64;icp.es
          </a>
        </p>
      </div>
    </div>
  </div>
</div>

@if(visibleConfirmEditModal){
<aig-modal-confirm-edit (hideModal)="CloseModal()"></aig-modal-confirm-edit>
}

@if (visibleEditIbanModal) {
  <aig-modal-edit-iban (hideModal)="visibleEditIbanModal = false" [lastDigits]="IbanLastDigits" [IdPoliza]="IdPoliza" (validationResult)="onValidationResult($event)"></aig-modal-edit-iban>
}
